import { render, staticRenderFns } from "./ReportAProblem.vue?vue&type=template&id=2c5ef9f0&scoped=true"
import script from "./ReportAProblem.vue?vue&type=script&lang=js"
export * from "./ReportAProblem.vue?vue&type=script&lang=js"
import style0 from "./ReportAProblem.vue?vue&type=style&index=0&id=2c5ef9f0&lang=scss"
import style1 from "./ReportAProblem.vue?vue&type=style&index=1&id=2c5ef9f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5ef9f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c5ef9f0')) {
      api.createRecord('2c5ef9f0', component.options)
    } else {
      api.reload('2c5ef9f0', component.options)
    }
    module.hot.accept("./ReportAProblem.vue?vue&type=template&id=2c5ef9f0&scoped=true", function () {
      api.rerender('2c5ef9f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/drc/components/ReportAProblem.vue"
export default component.exports